import React, { useState, useEffect, useMemo } from "react";
import { RootState } from "../../models/RootState";
import { NavLink, useParams } from "react-router-dom";
import "./ExchangeMarketsPage.scss";
import SAP_API from "../../services/sap";
import { connect, useSelector } from "react-redux";
import { BookMakers, EventData, LimitDto, MatchOdds, TopicUrls } from "../../models/EventData";
import MatchOddsTable from "../MatchOddsTable/MatchOddsTable";
import BMTable from "../BMTable/BMTable";
import FancyTable from "../FancyTable/fancyTable";
import { IonCol, IonRow } from "@ionic/react";
import { Accordion, AccordionDetails, Button, Checkbox, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel/TabPanel";
import PremiumMarkets from "../PremiumMarkets/PremiumMarkets";
import { fetchEventInfo, getAllMatchOddsData, getBookMakerMarkets } from "../../store/exchangeSports/exchangeSportsAction";
import moment from "moment";
import { ExpandLessSharp, ExpandMoreSharp } from "@mui/icons-material";
import LiveStream from "../LiveStream/LiveStream";
import { checkStompClientSubscriptions, disconnectToWS, subscribeForMatchOdds, subscribeSportRadarEventOdds, subscribeWsForBookmakerMarkets, subscribeWsForFancyMarkets } from "../../websockets/webSocket";
import ExchOpenBets from "../ExchOpenBets/ExchOpenBets";
import { UserBet } from "../../models/ExchBetSlip";
import { fetchOpenBets } from "../../store/exchBetSlip/exchBetSlipAction";
import { setEventInfoOnSuccess } from "../../store/exchangeSports/exchangeSportsReducer";
import { removeExchangeBet, setIsOneClickBettingEnabled } from "../../store/exchBetSlip/exchBetSlipReducer";
import { useNavigate } from "react-router";
import { setTextColor } from "../../store/authActions";
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import OneClickBetting from "../OneClickBetting";
import { OneClickBettingLoader } from "../OneClickBetting/OneClickLoader";
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";

type StoreProps = {
  eventInfo: EventData;
  openBets: UserBet[];
  fetchEventInfo: (sportId: any, eventId: any, navigate: Function) => void;
  fetchOpenBets: (eventId: string, sportId: string) => void;
  setEventInfoOnSuccess: () => void;
  removeExchangeBet: (index: number) => void;
  topicUrls?: TopicUrls;
  eventMarkets: MatchOdds[];
  bmMarkets: BookMakers[];
  betFairWSConnected: boolean;
  sportsRadarWSConnected: boolean;
  dreamWSConnected: boolean;
  wallets: any;
  Browser: any;
  isOneClickBettingEnabled: boolean;
  setIsOneClickBettingEnabled: (isOneClickBettingEnabled: boolean) => void;
  bettingInprogress: boolean;
};

export const ExchangeMarketsPage: React.FC<StoreProps> = (props) => {
  const {
    eventInfo,
    fetchEventInfo,
    openBets,
    fetchOpenBets,
    removeExchangeBet,
    topicUrls,
    eventMarkets,
    bmMarkets,
    betFairWSConnected,
    sportsRadarWSConnected,
    dreamWSConnected,
    setEventInfoOnSuccess,
    wallets,
    Browser,
    isOneClickBettingEnabled,
    setIsOneClickBettingEnabled,
    bettingInprogress,
  } = props;

  const { gameInfo } = useParams();
  const [sportId, competitionId, eventId] = atob(gameInfo || "").split("|");
  let [marketData, setMarketData] = useState<EventData | null>();
  const { exchData } = useSelector((state: RootState) => state.userDetails);
  const [tabVal, setTabVal] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [scorecardID, setScorecardID] = useState<string>('');
  const [fancyTabVal, setFancyTabVal] = useState(0);
  const navigate = useNavigate();
  const [scExpanded, setScExpanded] = useState(true);
  const [lsExpanded, setLsExpanded] = useState(true);
  const [obExpanded, setObExpanded] = useState(true);
  const [prLimits, setPRLimits] = useState<LimitDto>();
  const [bal, setBal] = useState<Number>(0);
  const [exp, setExp] = useState<Number>(0);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchEventInfo(sportId, eventId, navigate);
      fetchOpenBets(eventId, sportId);
      setLoading(false);
    };

    fetchData();
  }, []);

  const matchOddsMarkets = useMemo(
    () => eventMarkets?.filter((market) => market.marketName.toLowerCase() === "match odds"),
    [eventMarkets]
  );

  const nonMatchOddsMarkets = useMemo(
    () => eventMarkets?.filter((market) => market.marketName.toLowerCase() !== "match odds"),
    [eventMarkets]
  );

  useEffect(() => {
    const matchingWallet = wallets.find(
      (wallet: any) => wallet?.walletName === "POINTS"
    );
    if (matchingWallet) {
      setBal(matchingWallet?.balance);
      setExp(matchingWallet?.exposure);
    }
  }, [wallets]);

  useEffect(() => {
    return () => {
      setEventInfoOnSuccess()
      removeExchangeBet(0);
      disconnectToWS()
      setMarketData(null);
    };
  }, []);

  useEffect(() => {
    if (eventInfo?.eventId && eventInfo?.eventId !== "" && (betFairWSConnected || sportsRadarWSConnected || dreamWSConnected)) {
      if (eventInfo.markets.matchOdds.length > 0 && topicUrls?.matchOddsTopic) {
        for (let mo of eventInfo.markets.matchOdds) {
          subscribeForMatchOdds(
            topicUrls?.matchOddsTopic,
            "",
            eventInfo.eventId,
            mo.marketId
          );
        }
      }
      if (
        eventInfo.markets?.bookmakers &&
        eventInfo.markets?.bookmakers?.length > 0 &&
        topicUrls?.bookMakerTopic
      ) {
        for (let bm of eventInfo.markets.bookmakers) {
          subscribeWsForBookmakerMarkets(topicUrls?.bookMakerTopic, eventInfo.eventId, bm.marketId);
        }
      }

      if (
        eventInfo?.markets?.fancyMarkets &&
        eventInfo?.markets?.fancyMarkets?.length > 0 &&
        topicUrls?.fancyTopic
      ) {
        subscribeWsForFancyMarkets(topicUrls?.fancyTopic, eventInfo.eventId);
      }

      if (eventInfo && eventInfo?.markets?.premiumMarkets && eventInfo?.markets?.premiumMarkets?.length > 0 && topicUrls?.premiumTopic) {
        subscribeSportRadarEventOdds(
          topicUrls?.premiumTopic,
          "",
          eventInfo?.markets?.premiumEventId
        );
      }
    }
  }, [betFairWSConnected, eventInfo?.eventId, sportsRadarWSConnected, dreamWSConnected]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
  
      if (event.data?.type === "SCORECARD_HEIGHT") {
        const iframe = document.getElementById("scorecard-frame");
        if (iframe) iframe.style.height = `${event.data.height}px`;
      }
    };
  
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  

  useEffect(() => {
    if (topicUrls?.matchOddsBaseUrl) {
      const baseUrlsPayload = {
        matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
        bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
        premiumBaseUrl: topicUrls?.premiumBaseUrl,
      };
      checkStompClientSubscriptions(baseUrlsPayload);
    }
  }, [topicUrls]);

  useEffect(() => {
    if (eventInfo?.markets?.premiumMarkets?.length > 0 && prLimits?.minBetValue === undefined) {
      const limitsDto = eventInfo?.markets?.premiumMarkets?.[0]?.limits
      if (limitsDto?.minBetValue) {
        setPRLimits({
          minBetValue: limitsDto?.minBetValue,
          maxBetValue: limitsDto?.maxBetValue,
          oddsLimit: limitsDto?.oddsLimit,
        });
      }
    }
  }, [eventInfo?.markets?.premiumMarkets]);

  useEffect(() => {
    setMarketData(eventInfo);
  }, [eventInfo]);

  useEffect(() => {
    if (
      fancyTabVal === 0 && marketData?.markets?.fancyMarkets?.length === 0
    ) {
      setFancyTabVal(1); // Switch to "PREMIUM" tab if "FANCY" is empty
    }
  }, [marketData]);

  const getSREventIdByBetFairId = async () => {
    try {
      await SAP_API.post(`/feed/get-sr-event`, {
        eventId: eventInfo?.eventId.split('_').join(':'),
      }).then((result: any) => {
        if (result?.data?.status === 'RS_OK')
          setScorecardID(
            result?.data?.srEventDetails?.srEventId?.split(':')[2]
          );
        else setScorecardID("");
      });
    } catch (err) {
      setScorecardID("");
    }
  };

  useEffect(() => {
    const tg = window?.Telegram?.WebApp;

    tg?.BackButton?.show();

    tg?.expand();

    const telegramVersion = parseFloat(tg?.version || "0");
    if (telegramVersion >= 8.0) {
      // tg?.requestFullscreen();
      tg?.lockOrientation();
    }

    const backClickHandler = () => {
      handleBackClick();
    };

    tg?.BackButton?.onClick(backClickHandler);

    return () => {
      tg?.BackButton?.hide();
      tg?.BackButton?.offClick(backClickHandler);
      const telegramVersion = parseFloat(tg?.version || "0");
      if (telegramVersion >= 8.0) {
        // tg?.exitFullscreen();
        if (tg?.isOrientationLocked) {
          tg?.unlockOrientation();
        }
      }
    };
  }, []);

  useEffect(() => {
    if (eventInfo?.eventId) {
      // if (eventInfo?.providerName?.toLocaleLowerCase() === "sportradar") {
      //   setScorecardID(eventInfo?.eventId?.split("sr:match:")?.[1]);
      // } else {
      //   getSREventIdByBetFairId()
      // }
      setScorecardID(eventInfo?.eventId);
    }
  }, [eventInfo?.eventId]);

  useEffect(() => {
    if (tabVal === 2) {
      fetchOpenBets(eventInfo?.eventId, eventInfo?.sportId)
    }
  }, [tabVal]);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      {/* One-click betting loader overlay */}
      {isOneClickBettingEnabled && bettingInprogress && (
        <div className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center">
          <OneClickBettingLoader />
        </div>
      )}

      {
        loading ? (
          <div className="home-loading">
            <img src={`/${Loader(domain)}`} style={{ height: '10rem' }} />
          </div>
        ) : (
          <>
            <IonRow className="eam-ctn">
              <IonCol className="mob-stream-section">
                <IonRow className="eam-info-header eam-info-header-name">
                  <div className="eam-teams-name">
                    <div className="flex items-center">
                      {
                        Browser === "Web" && (
                          <div className="flex items-center h-[40px] px-[7px] rounded-[40px] back-btn">
                            <FontAwesomeIcon
                              icon={faChevronLeft}
                              onClick={handleBackClick}
                              className="cursor-pointer object-contain shrink-0"
                            />
                          </div>
                        )
                      }
                      <div className={`${setTextColor(getComputedStyle(document.body).getPropertyValue('--team-info-background'))} eam-teams-name-ctn`}>
                        <div className="eam-team-1">{eventInfo?.eventName}</div>
                        <div className="eam-date-time">
                          <span>
                            {moment(
                              eventInfo?.openDate
                            ).format('hh')}
                          </span>
                          :
                          <span>
                            {moment(
                              eventInfo?.openDate
                            ).format('mm A')}
                          </span>&nbsp;
                          {moment(
                            eventInfo?.openDate
                          ).format('DD MMM YYYY')}
                        </div>
                      </div>
                    </div>

                    <div className="eam-bal-ctn">
                      <div className={`${setTextColor(getComputedStyle(document.body).getPropertyValue('--team-info-background'))} eam-bal`}>
                        <div>
                          {'bal: '}
                          <span className="bal-value">{bal.toFixed(2)}</span>
                        </div>
                        <div>
                          {'exp: ' + exp.toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                </IonRow>

                {
                  // isMobile &&
                  (
                    // openBets.length > 0 ||
                    // (eventInfo && eventInfo.status === 'IN_PLAY')) ? (
                    <>
                      <Tabs
                        value={tabVal}
                        className="eam-all-markets-header-tabs"
                        onChange={(_, newValue) => {
                          setTabVal(newValue);
                        }}
                      >
                        <Tab
                          label={
                            <div className="flex items-center gap-2">
                              <span>SCORECARD</span>
                              {
                                <span onClick={(e) => {
                                  e.stopPropagation();
                                  setScExpanded(!scExpanded);
                                }}
                                  className="cursor-pointer">
                                  {scExpanded ? <ExpandLessSharp /> : <ExpandMoreSharp />}
                                </span>
                              }
                            </div>
                          }
                          value={0}
                          disabled={['99990', '2378961'].includes(eventInfo?.sportId)}
                        />
                        {!['101480', 'sr:tournament:2472'].includes(eventInfo?.competitionId) && (
                          <Tab
                            label={
                              <div className="flex items-center gap-2">
                                <span>LIVE STREAM</span>
                                {
                                  <span onClick={(e) => {
                                    e.stopPropagation();
                                    setLsExpanded(!lsExpanded);
                                  }}
                                    className="cursor-pointer">
                                    {lsExpanded ? <ExpandLessSharp /> : <ExpandMoreSharp />}
                                  </span>
                                }
                              </div>
                            }
                            value={1}
                            disabled={
                              !(eventInfo && eventInfo.status === 'IN_PLAY') ||
                              ['99990', '2378961'].includes(eventInfo?.sportId)
                            }
                          />
                        )}
                        <Tab
                          label={
                            <div className="flex items-center gap-2">
                              <span>OPEN BETS ({openBets?.length || 0}) </span>
                              {
                                <span onClick={(e) => {
                                  e.stopPropagation();
                                  setObExpanded(!obExpanded);
                                }}
                                  className="cursor-pointer">
                                  {obExpanded ? <ExpandLessSharp /> : <ExpandMoreSharp />}
                                </span>
                              }
                            </div>
                          }
                          value={2}
                        />
                      </Tabs>
                      <TabPanel
                        value={tabVal}
                        index={0}
                        className="event-stat-mobile-ctn"
                      >
                        <div>
                          {tabVal === 0 &&
                            eventInfo &&
                            eventInfo.sportId !== '99990' &&
                            scorecardID &&
                            (eventInfo.status === 'IN_PLAY' ||
                              eventInfo.status === 'SUSPENDED') ? (
                            <>
                              {scExpanded && (
                                <Accordion
                                  className="scorecard-accordion"
                                  expanded={true}
                                >
                                  {/* <AccordionSummary
                          expandIcon={
                            <ExpandLessSharp className="expand-icon" />
                          }
                          aria-controls="panel1a-content"
                          className="scorecard-header"
                        >
                          {"Live Score"}
                        </AccordionSummary> */}
                                  <AccordionDetails className="scorecard-detail">
                                    <div className="widgets">
                                      <div>
                                        <div className="sr-widget sr-widget-1">
                                          {eventInfo && (
                                            <iframe
                                              id="scorecard-frame"
                                              src={`https://win.mysportsfeed.io/?sportId=${eventInfo.sportId}&eventId=${eventInfo.eventId}`}
                                              width="100%"
                                              height="0"
                                              title="Scorecard"
                                            />
                                          )}
                                        </div>
                                        {/* <>
                                          {eventInfo?.sportId === "sr:sport:21" || eventInfo?.sportId === "4" ? (
                                            <Script
                                              strategy="afterInteractive"
                                              dangerouslySetInnerHTML={{
                                                __html: `
          (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
          g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
          )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
          theme: false, // using custom theme
          language: "en"
          });
          SIR("addWidget", ".sr-widget-1", "match.lmtlight", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum",  activeSwitcher: "scoreDetails", matchId:"${scorecardID}"});
        `,
                                              }}
                                            />
                                          ) : (
                                            <Script
                                              strategy="afterInteractive"
                                              dangerouslySetInnerHTML={{
                                                __html: `
          (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
          g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
          )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
          theme: false, // using custom theme
          language: "en"
          });
          SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum",  activeSwitcher: "scoreDetails", matchId:"${scorecardID}"});
        `,
                                              }}
                                            />
                                          )}
                                        </> */}
                                      </div>
                                    </div>
                                  </AccordionDetails>
                                </Accordion>
                              )}
                            </>
                          ) : null}
                        </div>
                      </TabPanel>
                      <TabPanel
                        value={tabVal}
                        index={1}
                        className="eam-header-tab-panel"
                      >
                        {!['101480', 'sr:tournament:2472'].includes(eventInfo?.competitionId) && tabVal === 1 ? (
                          <>
                            {lsExpanded && (
                              <div className="live-stream-ctn">
                                <LiveStream
                                  eventID={
                                    eventInfo?.sportId === '99994'
                                      ? eventInfo?.markets?.bookmakers?.length > 0
                                        ? eventInfo.eventId
                                        : 'sr:match:' + scorecardID
                                      : eventInfo?.markets?.matchOdds?.length === 0 &&
                                        eventInfo?.markets?.bookmakers?.length > 0 &&
                                        eventInfo?.markets?.premiumMarkets?.length > 0
                                        ? 'sr:match:' + scorecardID
                                        : eventInfo.eventId
                                  }
                                />
                              </div>
                            )}
                          </>
                        ) : null}
                      </TabPanel>
                      <TabPanel
                        value={tabVal}
                        index={2}
                        className="event-stat-mobile-ctn"
                      >
                        {obExpanded && (
                          <>
                            {openBets.length > 0 ? (
                              <ExchOpenBets />
                            ) : (
                              <>
                                <div className="no-bet-data mob-open-bets-ctn">
                                  {"No open bets to show"}
                                </div>
                              </>
                            )}
                            <div className="btn-background">
                              <div className={`${setTextColor(getComputedStyle(document.body).getPropertyValue('--ion-button-color'))} btn-mybets`}>
                                <NavLink to={`/betlist`}>
                                  <Button>{"VIEW ALL"}</Button>
                                </NavLink>
                              </div>
                            </div>
                          </>
                        )}
                      </TabPanel>
                    </>
                  )}
              </IonCol>
              <IonCol className="eam-events-table-section">
                {
                  marketData?.providerName?.toLocaleLowerCase() === "sportradar" ?
                    <div className="">
                      <IonRow className="eam-table-section fancy-tab-section">
                        <PremiumMarkets limits={prLimits} />
                      </IonRow>
                    </div>
                    : (
                      <div className="">
                        <IonRow className="eam-table-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.matchOdds &&
                            matchOddsMarkets ? (
                            <MatchOddsTable eventMarkets={matchOddsMarkets} />
                          ) : null}
                        </IonRow>

                        <IonRow className="eam-table-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.bookmakers &&
                            marketData.markets.bookmakers.length ? (
                            <BMTable bmMarkets={bmMarkets} />
                          ) : null}
                        </IonRow>

                        <IonRow className="eam-table-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.matchOdds &&
                            nonMatchOddsMarkets ? (
                            <MatchOddsTable eventMarkets={nonMatchOddsMarkets} />
                          ) : null}
                        </IonRow>

                        <IonRow className="eam-table-section fancy-tab-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.fancyMarkets &&
                            (marketData.markets.fancyMarkets.length > 0 ||
                              marketData.markets.premiumMarkets.length > 0) ? (
                            // <FancyTable fmData={marketData.markets.fancyMarkets} />
                            <>
                              <Tabs
                                value={fancyTabVal}
                                className="fancy-market-tabs"
                                onChange={(_, newValue) => {
                                  setFancyTabVal(newValue);
                                }}
                              >
                                {marketData?.markets?.fancyMarkets?.length > 0 ? (
                                  <Tab
                                    label={"FANCY"}
                                    className="fancy-tab"
                                    value={0}
                                  />
                                ) : null}
                                {marketData?.markets?.premiumMarkets?.length > 0 ? (
                                  <Tab
                                    label={"PREMIUM"
                                    }
                                    className="fancy-tab premium-markets"
                                    value={1}
                                  />
                                ) : null}
                              </Tabs>
                              <div className="fancy-tab-border"></div>
                              <IonRow>
                                <TabPanel
                                  value={fancyTabVal}
                                  index={0}
                                  className="fancy-tab-ctn"
                                >
                                  {marketData?.markets?.fancyMarkets?.length > 0 ? (
                                    <>
                                      <FancyTable />
                                    </>
                                  ) : (
                                    <div className="no-fancy-msg">
                                      {"No Fancy Markets"}
                                    </div>
                                  )}
                                </TabPanel>

                                <IonRow className="row-100">
                                  {' '}
                                  <TabPanel
                                    value={fancyTabVal}
                                    index={1}
                                    className="fancy-tab-ctn"
                                  >
                                    {marketData?.markets?.premiumMarkets?.length > 0 ? (
                                      <>
                                        <PremiumMarkets limits={prLimits} />
                                      </>
                                    ) : (
                                      <div className="no-fancy-msg">
                                        {"No Premium Markets"}
                                      </div>
                                    )}
                                  </TabPanel>
                                </IonRow>
                              </IonRow>
                            </>
                          ) : null}

                          {/* <MarketPremium /> */}
                        </IonRow>
                      </div>
                    )
                }
                {isOneClickBettingEnabled ? (
                  <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[1000] w-[95%] max-w-[450px]">
                    <OneClickBetting lobby={"EXCHANGE"} />
                  </div>
                ) : (
                  <div
                    className="bg-[var(--table-bg)] rounded-lg p-2 m-1 mb-4 flex items-center justify-between"
                  >
                    <div
                      className="flex items-center text-xs text-gray-200 font-medium"
                    >
                      <Checkbox
                        color="primary"
                        onClick={() =>
                          setIsOneClickBettingEnabled(!isOneClickBettingEnabled)
                        }
                        checked={isOneClickBettingEnabled}
                        className="text-[var(--ion-color-primary)] pr-1"
                        size="small"
                        style={{
                          padding: '0px',
                          transform: 'scale(0.7)',
                          color: 'var(--ion-color-primary)'
                        }}
                      />
                      1 Click Betting Enabled
                    </div>
                  </div>
                )}
                {marketData?.markets?.matchOdds?.length == 0 &&
                  marketData?.markets?.bookmakers?.length == 0 &&
                  marketData?.markets?.fancyMarkets?.length == 0 &&
                  marketData?.markets?.premiumMarkets?.length == 0 && (
                    <div className="no-fancy-msg">No Markets Available</div>
                  )}
              </IonCol>
            </IonRow>
          </>
        )
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    topicUrls: state?.exchangeSports?.topicUrls,
    eventInfo: state?.exchangeSports.eventInfo,
    betFairWSConnected: state?.exchangeSports?.betFairWSConnected,
    sportsRadarWSConnected: state?.exchangeSports?.sportsRadarWSConnected,
    openBets: state?.exchBetSlip?.openBets,
    dreamWSConnected: state?.exchangeSports?.dreamWSConnected,
    eventMarkets: getAllMatchOddsData(state.exchangeSports.eventInfo),
    bmMarkets: getBookMakerMarkets(state.exchangeSports.eventInfo),
    wallets: state.userDetails?.wallets,
    Browser: state.userDetails.Browser,
    isOneClickBettingEnabled: state?.exchBetSlip?.isOneClickBettingEnabled,
    oneClickBettingStake: state?.exchBetSlip?.oneClickBettingStake,
    bettingInprogress: state?.exchBetSlip?.bettingInprogress,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setEventInfoOnSuccess: () => dispatch(setEventInfoOnSuccess({})),
    fetchOpenBets: (eventId: string, sportId: string) => dispatch(fetchOpenBets(eventId, sportId)),
    fetchEventInfo: (sportId: string, eventId: string, navigate: Function) => dispatch(fetchEventInfo(sportId, eventId, navigate)),
    setIsOneClickBettingEnabled: (isOneClickBettingEnabled: boolean) => dispatch(setIsOneClickBettingEnabled(isOneClickBettingEnabled)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeMarketsPage);
